import React, { useEffect, useRef, useState } from 'react';

let observer;
const callbacks = new WeakMap();

const observe = (el, cb) => {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          callbacks.get(entry.target)?.();
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
  }
  callbacks.set(el, cb);
  observer.observe(el);
  return () => observer.unobserve(el);
};

/** Fades + rises its children into place the first time they scroll into view. */
const Reveal = ({ as: Tag = 'div', delay = 0, className = '', style, children, ...rest }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => observe(ref.current, () => setShown(true)), []);

  return (
    <Tag
      ref={ref}
      className={`reveal${shown ? ' is-shown' : ''} ${className}`}
      style={delay ? { '--reveal-delay': `${delay}s`, ...style } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
